<template>
  <el-container class="login-bg">
    <div class="login-content">
      <el-container class="login-content-right">
        <el-header height="180px" style="padding: 0;margin-bottom: 10px;text-align: center">
          <el-row style="margin: 25px 0 15px"><img src="../assets/login_logo.png" style="width: 70px"></el-row>
          <span style="font-size: 16px;color: #333;font-weight: 600">欢迎登录</span>
          <h3 style="font-size: 20px;color: #333;margin-top: 2px;">河南律师之家管理员登录系统</h3>
        </el-header>
        <p style="font-size: 14px;margin: 0;color: red;height: 20px">{{msg}}</p>
        <el-form v-model="loginRequest" class="login_form">
          <el-form-item>
            <label>用户名</label>
            <el-input type="text" placeholder="请输入用户名" v-model="loginRequest.username">
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 60px;">
            <label>密码</label>
            <el-input type="password" placeholder="请输入密码" v-model="loginRequest.password">
            </el-input>
          </el-form-item>
          <el-form-item style="text-align: center">
            <el-button type="primary" @click="login" @keyup.enter.native="login">登录</el-button>
          </el-form-item>
        </el-form>
        <!--<el-row style="font-size: 14px;color: #666;text-align: center;margin-top: 100px">© Chinese Henan Yixing Technology Co. Ltd.</el-row>-->
      </el-container>
    </div>
  </el-container>
</template>

<script>
import login from '@/api/login'
export default {
  name: 'Login',
  data () {
    return {
      loginRequest: {
        username: '',
        password: ''
      },
      msg: ''
    }
  },
  methods: {
    login () {
      login.userlogin(this.loginRequest).then(res => {
        if (res.data.code === 0) {
          this.$store.dispatch('changeToken', res.data.data.token)
          this.$store.dispatch('username',res.data.data.sysUser.username)
          this.$store.dispatch('userId',res.data.data.sysUser.id)
          // this.$router.push({path: '/video/live'})
          this.$router.push({path: '/index'})
        } else {
          this.msg = res.data.message
        }
      })
    }
  },
  //离开页面后，阻止回车事件
  destroyed() {
    document.onkeydown = undefined
  },
  created(){
    let _this= this
    document.onkeydown = function (e) {//监听回车键
      if(e.keyCode && e.keyCode==13){
        _this.login()
      }
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue